import { X, LinkedinIcon, YoutubeIcon, Mail } from 'lucide-react';
import logoImg from '../../assets/97af715ab6a3414a5586695e213784f67e1e0ed5.png';

type FooterProps = {
  onRequestDemo: () => void;
  onNavigateToSpecialized?: () => void;
};

export const Footer = ({ onRequestDemo, onNavigateToSpecialized }: FooterProps) => {
  const handleSpecializedClick = () => {
    if (onNavigateToSpecialized) {
      onNavigateToSpecialized();
      // Small delay to ensure navigation happens first
      setTimeout(() => {
        const element = document.getElementById('specialized-offerings');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-16">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={logoImg}
                alt="Anuvadini AI - Make in India Global Translation Platform"
                className="h-20 w-auto rounded-2xl bg-white/5 p-2"
                loading="lazy"
              />
              <span className="text-2xl font-bold">Anuvadini</span>
            </div>
            <p className="text-gray-400 mb-8 leading-relaxed text-justify-inter-word">
              Breaking language barriers with high-performance multilingual AI solutions for enterprises worldwide.
            </p>
            <div className="flex gap-4">
              <a
                href="https://x.com/anuvadini?s=11"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <X size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/anuvadini-ai?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <LinkedinIcon size={18} />
              </a>
              <a
                href="https://youtube.com/@anuvadinineat?si=c-EvXv84ciYSJFjf"
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-orange-500 transition-colors"
              >
                <YoutubeIcon size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-lg">Product Line</h4>
            <ul className="space-y-4 text-gray-400">
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini Translation</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini Print</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini GEO-AI</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini AI Agents</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini Bharatt</a></li>
              <li><a href="#" className="hover:text-orange-500 transition-colors">Anuvadini Web & Mobile</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-lg">Specialized Offerings</h4>
            <ul className="space-y-4 text-gray-400">
              <li>
                <button 
                  onClick={handleSpecializedClick}
                  className="hover:text-orange-500 transition-colors text-left"
                >
                  Anuvadini Voice, Audio & Video
                </button>
              </li>
              <li>
                <button 
                  onClick={handleSpecializedClick}
                  className="hover:text-orange-500 transition-colors text-left"
                >
                  Anuvadini Games
                </button>
              </li>
              <li>
                <button 
                  onClick={handleSpecializedClick}
                  className="hover:text-orange-500 transition-colors text-left"
                >
                  Anuvadini Drafting & OCR
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-lg">Contact</h4>
            <p className="text-gray-400 mb-4 text-sm text-justify-inter-word">
              Talk to our team about enterprise AI solutions and integrations.
            </p>
            <div className="space-y-3 text-sm">
              <a
                href="mailto:cconeat@aicte-india.org"
                className="flex items-center gap-2 text-gray-300 hover:text-orange-500 transition-colors"
              >
                <Mail size={18} />
                cconeat@aicte-india.org
              </a>
              <button
                type="button"
                onClick={onRequestDemo}
                className="inline-flex items-center justify-center rounded-xl bg-green-400 px-4 py-2 font-semibold text-white hover:bg-green-500 transition-colors"
              >
                 Request a Demo
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-sm">
          <p>© 2026 Anuvadini AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};